import {PayloadAction} from "@reduxjs/toolkit";
import {CardDto} from "../../../common";
import {call, put} from "redux-saga/effects";
import {api} from "../../../api/api";
import {cardsActions} from "../../cards.slice";

export function* loadCardSaga(action: PayloadAction<string>) {
    const cardId = action.payload;

    try {
        const card: CardDto = yield call(api.loadCard, cardId);
        yield put(cardsActions.put([card]));
    } catch {
        // Handle errors but don't add anything to the store
        // Error loading card
    }
}